import validatorBuilder from 'validator-builder';

let personneCaracteristiquesValidator = null;

export default class PersonneCaracteristiques {
    constructor(data) {
        personneCaracteristiquesValidator = personneCaracteristiquesValidator || validatorBuilder.getInstanceFor('PersonneCaracteristiques');
        personneCaracteristiquesValidator.clearRules();
        personneCaracteristiquesValidator.generateRules();

        this.data = {};
        for (const element in data) {
            if (element !== 'data') {
                this[element] = data[element];
                this.data[element] = {
                    id: parseInt(element),
                    value: getFormattedValues(data[element]),
                    additionalInformations: { key: 'clé', value: 'valeur' }
                };
            }
        }

        function getFormattedValues(element) {
            if (Array.isArray(element)) {
                const result = _.map(element, function (e) {
                    if (e && e.hasOwnProperty('key')) {
                        return { value: e.key };
                    }
                    return { value: e };
                });
                return result;
            }
            return element;
        }
    }

    isValid() {
        const validationResults = personneCaracteristiquesValidator.validate(this);
        return validationResults.isValid;
    }
}
